<!-- //
组件-轮播图
@auth xuyd
@date 2024-05-03
//-->
<template>
  <PropsWrapper :widgetProps="widgetProps">
    <!--    <el-form @submit.native.prevent class="widget-banner-form" :v-model="formProps" size="small" :label-width="this.dvContants.labelWidth">-->
    <!--      <el-tag type="warning" size="small" :disable-transitions="false" style="margin:10px auto; width: 100%">-->
    <!--        图片宽度750px，高度300px的比例尺寸。-->
    <!--      </el-tag>-->
    <!--      <el-form-item prop="widgetName" label="名称">-->
    <!--        <el-input v-model="formProps.title" style="width: 100%" maxlength="20"></el-input>-->
    <!--      </el-form-item>-->

    <!--      <div class="banner-item" v-for="(item, index) in formProps.imgList" :key="index">-->
    <!--        <el-form-item prop="imgUrl" label="图片地址">-->
    <!--          <el-input style="width: 100%" v-model="item.imgUrl" clearable placeholder="图片地址（输入或者上传）">-->
    <!--            <el-popover-->
    <!--                slot="append"-->
    <!--                placement="top-start"-->
    <!--                width="160"-->
    <!--                popper-class="popper-fit"-->
    <!--                trigger="hover">-->
    <!--              <el-image style="width: 150px; height: 100px;" :src="item.imgUrl" fit="contain"/>-->
    <!--              <el-button slot="reference" icon="el-icon-view"/>-->
    <!--            </el-popover>-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item prop="imgLink" label="跳转地址">-->
    <!--          <el-input style="width: 100%" v-model="item.imgLink" clearable placeholder="跳转地址"/>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item style="text-align: right">-->
    <!--          <el-button type="text" icon="el-icon-plus" size="small" @click="handleAdd(index)"/>-->
    <!--          <el-button type="text" icon="el-icon-delete" size="small" @click="handleDelete(index)"/>-->
    <!--        </el-form-item>-->
    <!--      </div>-->
    <!--    </el-form>-->
  </PropsWrapper>
</template>

<script>

export default {
  name: 'WidgetBannerForm',
  components: {},
  data() {
    return {}
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    viewProps() {
      return this.widgetProps.viewProps;
    }
  },
  methods: {
    // buildData() {
    //   return {imgUrl: null, imgLink: null};
    // },
    // handleAdd(index) {
    //   console.log("index", index)
    //   this.formProps.imgList = this.formProps.imgList || [];
    //   this.formProps.imgList.splice(index + 1, 0, this.buildData());
    //
    //   console.log("index", this.formProps.imgList)
    // },
    // handleDelete(index) {
    //   this.formProps.imgList.splice(index, 1);
    //   if (this.formProps.imgList.length <= 0) {
    //     this.handleAdd(0);
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
:deep(.el-popover) {
  text-align: center !important;
}

:deep(.popper-fit) {
  padding: 2px !important;
  background-color: #3f5673 !important;
}

.banner-item {
  padding-top: 10px;
  border-top: 1px solid #3f5673;
}
</style>
